module.exports = __webpack_public_path__ + "static/img/11.7e7bd2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/11.png
// module id = 6lOL
// module chunks = 0